import { useContext } from 'react';
import { AuthContext } from './AuthContext';

export default function AuthProtectedComponent({ children }) {
  const { isAuthenticated, isGuest } = useContext(AuthContext);

  if (isAuthenticated || isGuest) {
    return children;
  } else {
    return null;
  }
}
